// [commons] widget

export enum PaymentProcessStep {
  USER_INFO = 'userInfo',
  DETAILS = 'paymentDetails',
  COMPLETE = 'paymentComplete',
}

export enum PaymentProcessStepBi {
  ShippingAddress = 'shipping_address',
  PaymentConfirm = 'payment_confirm',
}

export const PaymentProcessStepToBi = {
  [PaymentProcessStep.USER_INFO]: PaymentProcessStepBi.ShippingAddress,
  [PaymentProcessStep.DETAILS]: PaymentProcessStepBi.PaymentConfirm,
};
